<template>
  <q-dialog :visible="isVisible" :title="title" width="750px" :innerScroll="false" :showFooter="false" @close="onCancel" @cancel="onCancel">
    <el-table
      :data="tableData.list"
      ref="tableRef"
      border
      :height="380"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      v-loading="loading"
    >
      <el-table-column label="违规项" prop="categoryDetail"></el-table-column>
      <el-table-column label="场景" prop="scene"></el-table-column>
      <el-table-column label="扣分" prop="assessmentScore"></el-table-column>
      <el-table-column label="生效时间" prop="effectDate" width="180"></el-table-column>
      <el-table-column label="调整人" prop="lastUpdatedBy"></el-table-column>
      <el-table-column label="调整时间" prop="lastUpdateDate" width="160"></el-table-column>
    </el-table>
    <div height="auto" style="text-align: right; padding-top: 10px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="tableData.pageNum"
        :page-sizes="[30, 60, 90]"
        :page-size="tableData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="tableData.total"
      ></el-pagination>
    </div>
  </q-dialog>
</template>

<script>
import axios from "@/utils/axiosInstance";
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // refundReasonList: {
    //   type: Array,
    //   default: [],
    // },
    rowData: Object,
  },
  data() {
    return {
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      loading: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "调整记录";
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    init() {
      this.loading = true;
      let data = { ...this.currencyForm };
      data.reportCode = "qualityCheckProjectConfigModifyHis";
      data.queryMatch = [
        {
          attributeName: "dataId",
          val: this.rowData.dataId,
          op: "=",
        },
      ];
      data.pageNum = this.tableData.pageNum;
      data.pageSize = this.tableData.pageSize;
      data.hasCount = "Y"
      axios
        .post(`/ec-pc-api/custom/reports/data/qualityCheckProjectConfigModifyHis`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
};
</script>

<style lang="stylus" scoped>

>>> .el-dialog {
  margin: 50px auto !important
}

.content {
  max-height: 70vh
  overflow-y: auto
}
</style>
